__turbopack_context__.v({
  "animation-container": "niUD_W_animation-container",
  "animation-container-text-left": "niUD_W_animation-container-text-left",
  "animation-image": "niUD_W_animation-image",
  "animation-image-text-left": "niUD_W_animation-image-text-left",
  "buttonBar": "niUD_W_buttonBar",
  "green": "niUD_W_green",
  "hasImage": "niUD_W_hasImage",
  "heading": "niUD_W_heading",
  "imageContainer": "niUD_W_imageContainer",
  "search": "niUD_W_search",
  "searchWithImage": "niUD_W_searchWithImage",
  "singleImageLg": "niUD_W_singleImageLg",
  "singleImageMd": "niUD_W_singleImageMd",
  "singleImageSm": "niUD_W_singleImageSm",
  "singleImageXl": "niUD_W_singleImageXl",
  "teaser": "niUD_W_teaser",
  "teaserAnimated": "niUD_W_teaserAnimated",
  "teaserAnimatedTriggered": "niUD_W_teaserAnimatedTriggered",
  "textContainer": "niUD_W_textContainer",
  "textRight": "niUD_W_textRight",
  "white": "niUD_W_white",
  "withImage": "niUD_W_withImage",
});
